export default __webpack_public_path__ + "static/media/img-0580-iceland-half-face.bb0ed5e9.png";